import type { FC } from 'react'
import { Box } from '@chakra-ui/react'
import styles from './PinMarker.module.css'

/** Positioned by its parent AdvancedMarker; the CSS only draws the pin. */
const PinMarker: FC = () => {
  return (
    <Box position="relative">
      <Box className={styles.pin} />
      <Box className={styles.pulse} />
    </Box>
  )
}

export default PinMarker
